import diretor from './diretor';

// ==============================|| MENU ITEMS ||============================== //
const menuDiertor = {
  items: [diretor],
};

export default menuDiertor;
